import ACTIONS, { FETCH_STATUS } from "../constants";

// GET RUNBOOKS LIST
export const getRunbooksRequest = (state) => ({
  type: ACTIONS.RUNBOOKS_CALL,
  payload: state,
});

export const getRunbooksAttempt = {
  pending: { type: ACTIONS.RUNBOOKS.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.RUNBOOKS.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.RUNBOOKS.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// GET RUNBOOK DETAIL
export const getRunbookDetailRequest = (state) => ({
  type: ACTIONS.RUNBOOK_DETAIL_CALL,
  payload: state,
});

export const getRunbookDetailAttempt = {
  pending: { type: ACTIONS.RUNBOOK_DETAIL.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.RUNBOOK_DETAIL.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.RUNBOOK_DETAIL.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// CREATE RUNBOOK
export const createRunbookRequest = (state) => ({
  type: ACTIONS.CREATE_RUNBOOK_CALL,
  payload: state,
});

export const createRunbookAttempt = {
  pending: { type: ACTIONS.CREATE_RUNBOOK.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.CREATE_RUNBOOK.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.CREATE_RUNBOOK.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// UPDATE RUNBOOK
export const updateRunbookRequest = (state) => ({
  type: ACTIONS.UPDATE_RUNBOOK_CALL,
  payload: state,
});

export const updateRunbookAttempt = {
  pending: { type: ACTIONS.UPDATE_RUNBOOK.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.UPDATE_RUNBOOK.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.UPDATE_RUNBOOK.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// DELETE RUNBOOK
export const deleteRunbookRequest = (state) => ({
  type: ACTIONS.DELETE_RUNBOOK_CALL,
  payload: state,
});

export const deleteRunbookAttempt = {
  pending: { type: ACTIONS.DELETE_RUNBOOK.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.DELETE_RUNBOOK.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.DELETE_RUNBOOK.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// START RUNBOOK
export const startRunbookRequest = (state) => ({
  type: ACTIONS.RUNBOOK_START_CALL,
  payload: state,
});

export const startRunbookAttempt = {
  pending: { type: ACTIONS.RUNBOOK_START.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.RUNBOOK_START.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.RUNBOOK_START.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// STOP RUNBOOK
export const stopRunbookRequest = (state) => ({
  type: ACTIONS.RUNBOOK_STOP_CALL,
  payload: state,
});

export const stopRunbookAttempt = {
  pending: { type: ACTIONS.RUNBOOK_STOP.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.RUNBOOK_STOP.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.RUNBOOK_STOP.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// CREATE RUNBOOK ACTION
export const createRunbookActionRequest = (state) => ({
  type: ACTIONS.CREATE_RUNBOOK_ACTION_CALL,
  payload: state,
});

export const createRunbookActionAttempt = {
  pending: { type: ACTIONS.CREATE_RUNBOOK_ACTION.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.CREATE_RUNBOOK_ACTION.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.CREATE_RUNBOOK_ACTION.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// UPDATE RUNBOOK ACTION
export const updateRunbookActionRequest = (state) => ({
  type: ACTIONS.UPDATE_RUNBOOK_ACTION_CALL,
  payload: state,
});

export const updateRunbookActionAttempt = {
  pending: { type: ACTIONS.UPDATE_RUNBOOK_ACTION.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.UPDATE_RUNBOOK_ACTION.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.UPDATE_RUNBOOK_ACTION.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// DELETE RUNBOOK ACTION
export const deleteRunbookActionRequest = (state) => ({
  type: ACTIONS.DELETE_RUNBOOK_ACTION_CALL,
  payload: state,
});

export const deleteRunbookActionAttempt = {
  pending: { type: ACTIONS.DELETE_RUNBOOK_ACTION.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.DELETE_RUNBOOK_ACTION.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.DELETE_RUNBOOK_ACTION.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// COMPLETE RUNBOOK ACTION
export const completeRunbookActionRequest = (state) => ({
  type: ACTIONS.COMPLETE_RUNBOOK_ACTION_CALL,
  payload: state,
});

export const completeRunbookActionAttempt = {
  pending: { type: ACTIONS.COMPLETE_RUNBOOK_ACTION.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.COMPLETE_RUNBOOK_ACTION.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.COMPLETE_RUNBOOK_ACTION.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// DUPLICATE RUNBOOK
export const duplicateRunbookRequest = (state) => ({
  type: ACTIONS.DUPLICATE_RUNBOOK_CALL,
  payload: state,
});

export const duplicateRunbookAttempt = {
  pending: { type: ACTIONS.DUPLICATE_RUNBOOK.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.DUPLICATE_RUNBOOK.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.DUPLICATE_RUNBOOK.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// DUPLICATE RUNBOOK ACTION
export const duplicateRunbookActionRequest = (state) => ({
  type: ACTIONS.DUPLICATE_RUNBOOK_ACTION_CALL,
  payload: state,
});

export const duplicateRunbookActionAttempt = {
  pending: { type: ACTIONS.DUPLICATE_RUNBOOK_ACTION.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.DUPLICATE_RUNBOOK_ACTION.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.DUPLICATE_RUNBOOK_ACTION.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// REORDER RUNBOOK ACTION
export const reorderRunbookActionRequest = (state) => ({
  type: ACTIONS.REORDER_RUNBOOK_ACTION_CALL,
  payload: state,
});

export const reorderRunbookActionAttempt = {
  pending: { type: ACTIONS.REORDER_RUNBOOK_ACTION.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.REORDER_RUNBOOK_ACTION.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.REORDER_RUNBOOK_ACTION.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// GET RUNBOOK ACTION DETAIL
export const getRunbookActionDetailRequest = (state) => ({
  type: ACTIONS.RUNBOOK_ACTION_DETAIL_CALL,
  payload: state,
});

export const getRunbookActionDetailAttempt = {
  pending: { type: ACTIONS.RUNBOOK_ACTION_DETAIL.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.RUNBOOK_ACTION_DETAIL.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.RUNBOOK_ACTION_DETAIL.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// FLAG RUNBOOK

export const updateRunbookFlagRequest = (state) => ({
  type: ACTIONS.RUNBOOK_FLAG_CALL,
  payload: state,
});

export const updateRunbookFlagAttempt = {
  pending: {
    type: ACTIONS.RUNBOOK_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RUNBOOK_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RUNBOOK_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};